import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from '@/App';

import { MessageBox } from '@maxis/components';

import { SpinnerOverlay } from '@maxis/components';

import { ToastContainer } from 'react-toastify';
import ErrorBoundary from './ErrorBoundary';
import Toast from '@maxis/components/components/LoadingIndicator/Toast';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <ErrorBoundary>
        <BrowserRouter>
            <App />
        </BrowserRouter>
        <MessageBox />
        <SpinnerOverlay />
        <Toast />
    </ErrorBoundary>
);
